<template>
  <v-list-item
      @click="$emit('click')"
      class="notifications-list-item"
      :class="{'is-new': isNew}"
  >
    <v-list-item-avatar>
      <v-avatar :color="avatarColor" size="48">
        <span class="white--text">{{ notification.fromEmail.substr(0, 2).toUpperCase() }}</span>
      </v-avatar>
    </v-list-item-avatar>

    <v-list-item-content>
      <div class="meta-row">
        <div class="from-to">
          <p :class="textClass">{{ $t('notifications.item.from') }} {{ sender }}</p>
          <p :class="textClass">{{ $t('notifications.item.to') }} {{ receiver }}</p>
        </div>
        <time :class="textClass" class="text-caption">{{ notification.sentDatetime.toLocaleDateString() }}</time>
      </div>
      <div :class="textClass" class="text-subtitle-2 mt-2">{{ notification.messageHead }}</div>
      <div v-html="notification.messageText" class="notification-content text-caption mt-1"></div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import strToColor from "@/utils/strToColor";

export default {
  props: {
    notification: Object,
  },
  computed: {
    textClass() {
      return this.isNew ? 'primary--text' : null;
    },

    avatarColor() {
      return strToColor(this.notification.fromEmail);
    },

    isNew() {
      return this.notification.isUnread && this.notification.fromEmail !== this.$store.getters["app/user"].email;
    },

    sender() {
      if (this.notification.fromEmail === this.$store.getters["app/user"].email) {
        const rhName = (this.$store.getters["app/rightsholder"](this.notification.fromId) || {name: `RH# ${this.notification.fromId}`}).name
        return `${rhName} [Me]`;
      }
      if (this.notification.fromId === this.$store.getters["app/adminId"]) {
        return 'Admin';
      }
      const rh = this.$store.getters["app/rightsholder"](this.notification.fromId);
      if (rh) {
        return rh.name;
      }
      return this.notification.fromEmail;
    },

    receiver() {
      if (this.notification.receiverId === 0) {
        return this.$t('notifications.item.all')
      }
      if (this.notification.receiverId === this.$store.getters["app/adminId"]) {
        return this.$t('notifications.item.admin');
      }
      const rh = this.$store.getters['app/rightsholder'](this.notification.receiverId);
      if (rh) {
        return rh.name;
      }
      return 'RH# ' + this.notification.receiverId;
    }
  },
};
</script>

<style lang="scss" scoped>
.notifications-list-item {
  width: 100%;
  min-height: 100px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  margin-bottom: 12px !important;
}

.meta-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.from-to {
  p {
    margin-bottom: 0 !important;
    font-size: 11px;
    font-weight: bold;
  }
}

.notification-content {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}
</style>